module.exports = __webpack_public_path__ + "static/img/OPPO Enco X3.8559c1ea.png";